import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import './App.css'
import { useAuth } from './hooks/useAuth'
import router from './routers/AppRouter'
import { setIsAuthenticated, setAccessToken, setIsAuthLoading } from './state/auth.slice'
import { selectIsAuthLoading } from './state/auth.slice'

function App() {
  const { checkInitialAuth } = useAuth()
  const dispatch = useDispatch()
  const isAuthLoading = useSelector(selectIsAuthLoading)

  useEffect(() => {
    const restoreToken = async () => {
      try {
        const result = await checkInitialAuth()

        if (result.success) {
          const accessToken = localStorage.getItem('access_token')
          dispatch(setAccessToken(accessToken))
          dispatch(setIsAuthenticated(true))
        } else {
          dispatch(setIsAuthenticated(false))
          dispatch(setAccessToken(null))
        }
      } catch (error) {
        console.error(error)
      } finally {
        // Always set loading to false after auth check is complete
        dispatch(setIsAuthLoading(false))
      }
    }
    restoreToken()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  // Show loading screen while auth is being verified
  if (isAuthLoading) {
    return (
      <div className="App">
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontSize: '18px',
            color: '#666',
          }}
        >
          Loading...
        </div>
      </div>
    )
  }

  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  )
}

export default App
